import type { NumberIdModel } from '../id-model.interface';

export interface AccessManagementPermission {
  name: string;
  description: string;
  code: string;
  parentId?: number;
  parent?: AccessManagementPermission;
  children?: AccessManagementPermission[];
}

export type AccessManagementPermissionRecord = NumberIdModel &
  AccessManagementPermission;

export type AccessManagementPermissionTreeNode =
  AccessManagementPermissionRecord & { path: string };

export interface AccessManagementPermissionMap {
  [key: number]: AccessManagementPermissionRecord & { path: string };
}

export enum AccessManagementPermissionAPIReturnFormats {
  TREE = 'TREE',
  MAP = 'MAP',
  DEFAULT = 'DEFAULT',
}
